import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle,
  AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "../ui/alert-dialog";

export const DeleteLeadButton = ({ lead, onDelete }) => {
  const [busy, setBusy] = useState(false);
  const confirm = async () => {
    setBusy(true);
    try {
      await onDelete(lead.id);
      toast.success(`Deleted quote request ${lead.reference}`);
    } catch {
      toast.error("Could not delete this lead");
    } finally {
      setBusy(false);
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          type="button"
          data-testid={`admin-delete-button-${lead.reference}`}
          title="Delete quote request"
          className="inline-flex items-center justify-center w-10 h-10 rounded-lg border border-slate-300 bg-white text-slate-500 hover:text-red-700 hover:border-red-300 transition-colors"
        >
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="delete-lead-dialog" className="bg-white">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-slate-900">Delete this quote request?</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-600">
            {lead.name} · {lead.reference}. This permanently removes the lead, its notes and activity. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-lead-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="delete-lead-confirm" onClick={confirm} className="bg-red-600 hover:bg-red-700 text-white">
            Delete
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
